import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { setGender } from '../../store/slices/authSlice';
import { useTranslation } from 'react-i18next';

const YourGender = ({ nextPath = '/auth/interested', backPath = '/auth/first-name' }) => {
    const savedGender = useSelector(state => state.auth.gender);
    const [selectedGender, setSelectedGender] = useState(savedGender || '');
const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const genderOptions = [
        { value: 'F', label: t('yourGender.options.women') },
        { value: 'M', label: t('yourGender.options.men') }
    ];

    const handleNext = () => {
        if (selectedGender) {
            dispatch(setGender(selectedGender));
            navigate(nextPath);
        }
    };

    return (
        <div className="page-wrapper">
            <div className="page-content">
                <div className="container">
                    <div className="account-area style-2">
                        {/* Retour vers l'étape précédente de la logique du parcours (pas l'historique du navigateur : */}
                        {/* la redirection automatique de ProtectedAuthRoute peut remplacer l'historique réel) */}
                        <a href="#" onClick={(e) => { e.preventDefault(); navigate(backPath); }} className="back-btn">
                            <ChevronLeft className="icon" />
                        </a>
                        <div className="section-head ps-0">
                            <h2>{t('yourGender.title')}</h2>
                        </div>
                        <div className="radio style-3">
                            {genderOptions.map((option) => (
                                <label key={option.value} className="radio-label">
                                    <input
                                        type="radio"
                                        name="gender"
                                        checked={selectedGender === option.value}
                                        onChange={() => setSelectedGender(option.value)}
                                        aria-label={t('yourGender.ariaLabel', { gender: option.label })}
                                    />
                                    <span className="checkmark">                      
                                        <span className="text">{option.label}</span>                  
                                    </span>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <div className="footer fixed bg-white p-b15">
                <div className="container">
                    <button 
                        onClick={handleNext}
                        className="btn btn-lg btn-gradient w-100 dz-flex-box btn-shadow rounded-xl"
                        disabled={!selectedGender}
                    >
                        {t('yourGender.next')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default YourGender;
